import axios from "axios";
import {
  SIGN_IN,
  RESET_PASSWORD,
  GET_USER_INFO,
  UPDATE_USER_INFO,
  BASE_URL,
  FORGOT_PASSWORD,
  VERIFY_OTP,
  UPDATE_FORGOT_PASSWORD,
  RESEND_OTP,
} from "../util/constants";
import { sendRequest } from "./base";

export const signIn = async (data) => {
  try {
    return sendRequest(data, "POST", SIGN_IN, {});
  } catch (err) {
    return err;
  }
};
export const getUserInfo = async (id, token) => {
  try {
    const Authorization = `Bearer ${token}`;
    const options = {
      method: "GET",
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization,
      },
      url: `${BASE_URL}/${GET_USER_INFO}?Id=${id}`,
    };
    const { data } = await axios(options);
    if (data) return data;
  } catch (error) {
    return error;
  }
};
export const updateUserInfo = async (data, id, token) => {
  const Authorization = `Bearer ${token}`;
  const options = {
    method: "PUT",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization,
    },
    data: data,
    url: `${BASE_URL}/${UPDATE_USER_INFO}?Id=${id}`,
  };
  try {
    const { data } = await axios(options);
    if (data) return data;
    throw new Error("Something went wrong please try again");
  } catch (error) {
    throw new Error(error);
  }
};

export const resetPassword = async (data, token) => {
  const Authorization = `Bearer ${token}`;
  try {
    return sendRequest(data, "PUT", RESET_PASSWORD, { Authorization });
  } catch (err) {
    return err;
  }
};
export const forgotPassword = async (data) => {
  try {
    return sendRequest(data, "POST", FORGOT_PASSWORD, {});
  } catch (err) {
    return err;
  }
};
export const verifyOtp = async (data) => {
  try {
    return sendRequest(data, "POST", VERIFY_OTP, {});
  } catch (err) {
    return err;
  }
};
export const updateForgotPassword = async (data, token) => {
  const Authorization = `Bearer ${token}`;
  try {
    return sendRequest(data, "POST", UPDATE_FORGOT_PASSWORD, { Authorization });
  } catch (error) {
    return error;
  }
};
export const resendOtp = async (data) => {
  try {
    return sendRequest(data, "POST", RESEND_OTP, {});
  } catch (error) {
    return error;
  }
};

export const sendOtpForCashlessPaymentReceipt = async (data) => {
  try {
    return sendRequest(data, "POST", "paymentOnly/sendOtp", {});
  } catch (error) {
    return error;
  }
};

export const verifyOtpForCashlessPaymentReceipt = async (data) => {
  try {
    return sendRequest(data, "POST", "paymentOnly/verifyOtp", {});
  } catch (error) {
    return error;
  }
};
